module.exports = __webpack_public_path__ + "assets/images/hero-c7611193ffd0d5e6130c7baeab69aeda.jpg";